"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_property_decorator_1 = require("vue-property-decorator");
var axios_1 = __importDefault(require("axios"));
var dayjs_1 = __importDefault(require("dayjs"));
var DetailDataSingleLabel_1 = __importDefault(require("../../components/contract_form/DetailDataSingleLabel"));
var Torihikisaki_1 = __importDefault(require("../../components/sales_force/Torihikisaki"));
var date_parser_1 = __importDefault(require("../../../common/src/utils/date/date_parser"));
var TorihikisakiSekininsyaApply_1 = __importDefault(require("../../components/sales_force/TorihikisakiSekininsyaApply"));
var TorihikisakiSekininsyaTanto_1 = __importDefault(require("../../components/sales_force/TorihikisakiSekininsyaTanto"));
var entity_1 = require("../../../common/src/types/model/sales_force_info/entity");
var SimpleDialog_1 = __importDefault(require("../../components/globals/SimpleDialog"));
var Loading_1 = __importDefault(require("../../components/globals/Loading"));
var MoveSalesForceButton_1 = __importDefault(require("../../components/sales_force/MoveSalesForceButton"));
var PriceBookSelect_1 = __importDefault(require("../../components/sales_force/PriceBookSelect"));
var ApplicationDetails_1 = __importDefault(require("../../components/sales_force/ApplicationDetails"));
var ApplicationDetailsPre_1 = __importDefault(require("../../components/sales_force/ApplicationDetailsPre"));
var ReflectType_1 = require("../../../common/src/types/sales_force/ReflectType");
var value_checker_1 = __importDefault(require("../../../common/src/utils/validation/value_checker"));
var object_utils_1 = __importDefault(require("../../../common/src/utils/sales_force/object_utils"));
var OpportunityEntryPre_1 = __importDefault(require("../../components/sales_force/OpportunityEntryPre"));
var OpportunityBasicPre_1 = __importDefault(require("../../components/sales_force/OpportunityBasicPre"));
var OpportunityMediumPre_1 = __importDefault(require("../../components/sales_force/OpportunityMediumPre"));
var OpportunityOldStandardPre_1 = __importDefault(require("../../components/sales_force/OpportunityOldStandardPre"));
var OpportunityStandardPre_1 = __importDefault(require("../../components/sales_force/OpportunityStandardPre"));
var OpportunityProfessionalPre_1 = __importDefault(require("../../components/sales_force/OpportunityProfessionalPre"));
var OpportunityUpgradeToStandardPre_1 = __importDefault(require("../../components/sales_force/OpportunityUpgradeToStandardPre"));
var OpportunityAdditionalTabletPre_1 = __importDefault(require("../../components/sales_force/OpportunityAdditionalTabletPre"));
var OpportunityMotionAiPre_1 = __importDefault(require("../../components/sales_force/OpportunityMotionAiPre"));
var OpportunityUpgradePre_1 = __importDefault(require("../../components/sales_force/OpportunityUpgradePre"));
var ReflectSalesForcePre = /** @class */ (function (_super) {
    __extends(ReflectSalesForcePre, _super);
    function ReflectSalesForcePre() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.tab = null;
        _this.documentData = {
            documentId: '',
            applyInfoApplyService: [],
            applyInfoInputNumber: '',
            officeInfoRequestPersonLastName: '',
            officeInfoRequestPersonFirstName: '',
            officeInfoRequestPersonKanaLastName: '',
            officeInfoRequestPersonKanaFirstName: '',
            officeInfoRequestEmail: '',
            officeInfoOfficeNo: '',
            officeInfoCompanyName: '',
            officeInfoCompanyNameKana: '',
            officeInfoOfficeName: '',
            officeInfoOfficeNameKana: '',
            officeInfoZip1: '',
            officeInfoZip2: '',
            officeInfoAddress1: '',
            officeInfoAddress2: '',
            officeInfoAddress3: '',
            officeInfoTel: '',
            officeInfoCorporateName: '',
            officeInfoCompanyNo: '',
            officeInfoCorporateZip1: '',
            officeInfoCorporateZip2: '',
            officeInfoCorporateAddress1: '',
            officeInfoCorporateAddress2: '',
            officeInfoCorporateAddress3: '',
            requestInfoCompanyName: '',
            requestInfoTel: '',
            requestInfoZip1: '',
            requestInfoZip2: '',
            requestInfoAddress1: '',
            requestInfoAddress2: '',
            requestInfoAddress3: '',
            requestInfoRequestPersonLastName: '',
            requestInfoRequestPersonFirstName: '',
            requestInfoRequestEmail: '',
            requestInfoOfficeName: '',
            requestInfoHowToRequest: '',
            requestInfoHowToSend: '',
            requestInfoIsReadOnly: '',
            validUpgradeToStandardFlg: 'false',
            interimRequestInfoOfficeName: '',
            interimRequestInfoHojinName: '',
            interimRequestInfoZip1: '',
            interimRequestInfoZip2: '',
            interimRequestInfoAddress1: '',
            interimRequestInfoAddress2: '',
            interimRequestInfoAddress3: '',
            interimRequestInfoTel: '',
            interimRequestInfoEmail: '',
            interimRequestInfoPersonLastName: '',
            interimRequestInfoPersonFirstName: '',
            interimRequestInfoWay: '',
            interimRequestInfoNotification: '',
            alreadyEkycLatestRecord: null
        };
        _this.salesForceInfo = {
            documentId: '',
            lastUpdateUser: '',
            applyTorihikisakiId: '',
            torihikisakiId: '',
            opportunityId: '',
            corporateId: '',
            opportunityLeadSource: '',
            opportunityLtParentLs: '',
            opportunityLtSdate: '',
            opportunityGc: '',
            opportunityFtChildLs: '',
            opportunityLtChildLs: '',
            corporateEkycSkipFlg: '',
            personalEkycSkipFlg: '',
            alreadyEkycLatestRecord: null
        };
        _this.showAlertDialog = false;
        _this.alertDialogMessage = '';
        _this.showReCorrectDialog = false;
        _this.showAfterReCorrectDialog = false;
        _this.showStatusChangeDialog = false;
        _this.loading = false;
        _this.loadComplete = false;
        _this.disabledUpgradeToStandard = false;
        _this.disabledUpgradeTab = true;
        _this.showUpgradeTab = true;
        /**
         * Login中のSalesForceの UserID
         */
        _this.salesForceUserId = '';
        _this.signInEmail = '';
        /**
         * 価格表リスト全体
         */
        _this.priceBook2Data = [];
        /**
         * 既存の契約中商談との連続性を確認するためのリスト
         * DynamoDBに格納しない
         * @type {Array}
         */
        _this.contractStatusContinuityCheckRecord = [];
        /**
         * 価格表リスト各プラン別 forEach用
         */
        _this.priceBookDataList = [
            { priceBookName: 'priceBook2DataEntry', priceBookFlg: 'rehabCloudEntry' },
            { priceBookName: 'priceBook2DataBasic', priceBookFlg: 'rehabCloudBasic' },
            { priceBookName: 'priceBook2DataMedium', priceBookFlg: 'rehabCloudMedium' },
            { priceBookName: 'priceBook2DataOldStandard', priceBookFlg: 'rehabCloudStandardOld' },
            { priceBookName: 'priceBook2DataStandard', priceBookFlg: 'rehabCloudStandard' },
            { priceBookName: 'priceBook2DataProfessional', priceBookFlg: 'rehabCloudProfessional' },
            { priceBookName: 'priceBook2DataAdditionalTablet', priceBookFlg: 'rehabCloudTablet' },
            { priceBookName: 'priceBook2DataMotionAi', priceBookFlg: 'rehabCloudMotionAI' },
            { priceBookName: 'priceBook2DataUpgrade', priceBookFlg: 'rehabCloudUpGrade' }
        ];
        /**
         * 価格表リスト各プラン別
         */
        _this.priceBook2DataEntry = [];
        _this.priceBook2DataBasic = [];
        _this.priceBook2DataMedium = [];
        _this.priceBook2DataOldStandard = [];
        _this.priceBook2DataStandard = [];
        _this.priceBook2DataProfessional = [];
        _this.priceBook2DataAdditionalTablet = [];
        _this.priceBook2DataMotionAi = [];
        _this.priceBook2DataUpgrade = [];
        /**
         * Standardアップグレード対象リスト
         */
        _this.upgradeToStandardDataList = [];
        /**
         * Ekycスキップ判定用のオブジェクト
         */
        _this.alreadyEkycLatestRecord = null;
        return _this;
    }
    ReflectSalesForcePre_1 = ReflectSalesForcePre;
    ReflectSalesForcePre.prototype.dialogClose = function () {
        this.showStatusChangeDialog = false;
        this.showAlertDialog = false;
        this.showReCorrectDialog = false;
        this.showAfterReCorrectDialog = false;
    };
    ReflectSalesForcePre.prototype.movePage = function () {
        var routeData = this.$router.resolve({ path: "/update/" + this.getDocumentId_() });
        window.open(routeData.href, '_blank');
        this.dialogClose();
    };
    ReflectSalesForcePre.prototype.parseDate = function (dateStr) {
        return date_parser_1.default.toJapaneseDateStr(dateStr);
    };
    ReflectSalesForcePre.prototype.isLinkComplete = function (columnName) {
        console.log(this.salesForceInfo[columnName]);
        return this.salesForceInfo[columnName] === entity_1.SalesForceStatus.LINKD;
    };
    ReflectSalesForcePre.prototype.upgradeTabDisabled = function (validFlg) {
        this.documentData.validUpgradeToStandardFlg = validFlg;
        return JSON.parse(this.documentData.validUpgradeToStandardFlg.toLowerCase());
    };
    ReflectSalesForcePre.prototype.reflect = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var self_, authToken, url_, hasError, i, reflectType, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        self_ = this;
                        self_.startLoading();
                        Object.keys(data['salesForceInfo']).forEach(function (key) {
                            self_.salesForceInfo[key] = data['salesForceInfo'][key];
                        });
                        return [4 /*yield*/, this.getAuthToken()];
                    case 1:
                        authToken = _a.sent();
                        url_ = this.$invokeUrlMaker.create('sales_force/pre_post');
                        self_.salesForceInfo.lastUpdateUser = this.salesForceUserId;
                        hasError = false;
                        i = 0;
                        _a.label = 2;
                    case 2:
                        if (!(i < data['reflectType'].length)) return [3 /*break*/, 5];
                        reflectType = data['reflectType'][i];
                        return [4 /*yield*/, axios_1.default.post(url_, JSON.stringify({
                                salesForceInfo: self_.salesForceInfo,
                                document: self_.documentData,
                                reflectType: reflectType,
                                signInEmail: this.signInEmail
                            }), {
                                headers: {
                                    Authorization: "Bearer " + authToken
                                }
                            }).catch(function () {
                                self_.endLoading();
                                self_.alertDialogMessage = 'SalesForce連携で、エラーが発生しました。。開発に連絡してください！！';
                                self_.showAlertDialog = true;
                                hasError = true;
                            })];
                    case 3:
                        res = _a.sent();
                        if (res && res.data['apiResult']['errorMessage']) {
                            self_.alertDialogMessage = "\u767B\u9332\u306B\u5931\u6557\u3057\u307E\u3057\u305F\u3002\u3002<br>ErrorMessage: " + res.data['apiResult']['errorMessage'];
                            self_.showAlertDialog = true;
                            hasError = true;
                            self_.endLoading();
                            return [2 /*return*/];
                        }
                        if (hasError) {
                            return [3 /*break*/, 5];
                        }
                        self_.salesForceInfo = res.data['salesForceInfo'];
                        self_.documentData = res.data['documentData'];
                        // 連携完了したら、documentId をクリア！
                        if (data['reflectType'].includes(ReflectType_1.SalesForceReflectType.APPLICATION_DETAILS_PRE)) {
                            self_.setDocumentId_('');
                        }
                        else {
                            self_.setDocumentId_(self_.documentData.documentId);
                        }
                        _a.label = 4;
                    case 4:
                        i++;
                        return [3 /*break*/, 2];
                    case 5:
                        self_.alertDialogMessage = '登録しました！';
                        self_.showAlertDialog = true;
                        self_.endLoading();
                        return [2 /*return*/];
                }
            });
        });
    };
    ReflectSalesForcePre.prototype.getAuthToken = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.$cognito.authToken(ReflectSalesForcePre_1.LOGIN_REDIRECT_PATH_)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    ReflectSalesForcePre.prototype.loadSalesForceInfo = function (event) {
        return __awaiter(this, void 0, void 0, function () {
            var self_, upgradeTabControl, authToken, getAccountIdUrl, AccountIdData, error_1, contractStatusContinuitycUrl, obj, error_2, getAlreadyEkycUrl, alreadyEkycData, alreadyEkycArray, error_3, salesForceInfo;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        event.preventDefault();
                        self_ = this;
                        /*
                        if (ValueChecker.isBlank(this.salesForceInfo.torihikisakiId)) {
                            self_.alertDialogMessage = '取引先IDは必須の項目です！';
                            self_.showAlertDialog = true;
                            return;
                        }
                        */
                        if (value_checker_1.default.isBlank(this.salesForceInfo.applyTorihikisakiId)) {
                            self_.alertDialogMessage = '取引先責任者（申込者）IDは必須の項目です！';
                            self_.showAlertDialog = true;
                            return [2 /*return*/];
                        }
                        if (value_checker_1.default.isBlank(this.salesForceInfo.opportunityId)) {
                            self_.alertDialogMessage = '商談IDは必須の項目です！';
                            self_.showAlertDialog = true;
                            return [2 /*return*/];
                        }
                        upgradeTabControl = "" + this.$customEnv.get('UPGRADE_TAB_CONTROL');
                        console.log(upgradeTabControl, "これがUPGRADE_TAB_CONTROLです", "" + this.$customEnv.get('UPGRADE_TAB_CONTROL'));
                        this.showUpgradeTab = JSON.parse(upgradeTabControl);
                        // 取引先ID取得
                        self_.startLoading();
                        return [4 /*yield*/, self_.getAuthToken()];
                    case 1:
                        authToken = _a.sent();
                        getAccountIdUrl = self_.$invokeUrlMaker.create("sales_force/get_account_id/" + this.salesForceInfo.opportunityId);
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 4, , 5]);
                        return [4 /*yield*/, axios_1.default.get(getAccountIdUrl, {
                                headers: {
                                    Authorization: "Bearer " + authToken
                                }
                            })];
                    case 3:
                        AccountIdData = _a.sent();
                        if (value_checker_1.default.isPresent(AccountIdData.data.accountId)) {
                            this.salesForceInfo.torihikisakiId = AccountIdData.data.accountId;
                            self_.endLoading();
                        }
                        else {
                            self_.endLoading();
                            self_.alertDialogMessage = '商談IDが取引先と結びついていないか、他のIDを入力しています。';
                            self_.showAlertDialog = true;
                            return [2 /*return*/];
                        }
                        ;
                        if (value_checker_1.default.isPresent(AccountIdData.data.opportunityLineItemId)) {
                            self_.endLoading();
                            self_.alertDialogMessage = '入力された商談IDの商談にはすでに商談商品が紐づいています！';
                            self_.alertDialogMessage += '<br>商談商品が紐づいていない商談のIDを入力して下さい。';
                            self_.showAlertDialog = true;
                            return [2 /*return*/];
                        }
                        ;
                        return [3 /*break*/, 5];
                    case 4:
                        error_1 = _a.sent();
                        console.log(error_1);
                        self_.endLoading();
                        self_.alertDialogMessage = '取引先ID取得で、エラーが発生しました。。開発に連絡してください！！';
                        self_.showAlertDialog = true;
                        return [2 /*return*/];
                    case 5:
                        // 契約中の商談が新規に利用開始する申込みと連続性があるか判定する既存商談を取得する。
                        self_.startLoading();
                        contractStatusContinuitycUrl = self_.$invokeUrlMaker.create("sales_force/contract_status_continuity/" + self_.salesForceInfo.torihikisakiId);
                        _a.label = 6;
                    case 6:
                        _a.trys.push([6, 8, , 9]);
                        return [4 /*yield*/, axios_1.default.get(contractStatusContinuitycUrl, {
                                headers: {
                                    Authorization: "Bearer " + authToken
                                }
                            })];
                    case 7:
                        obj = _a.sent();
                        if (obj.data.contractStatusContinuityData.length !== 0) {
                            self_.contractStatusContinuityCheckRecord = obj.data.contractStatusContinuityData;
                        }
                        return [3 /*break*/, 9];
                    case 8:
                        error_2 = _a.sent();
                        console.log(error_2);
                        self_.endLoading();
                        self_.alertDialogMessage = '契約状況確認チェックの過程でエラーが発生しました。。開発に連絡してください！！';
                        self_.showAlertDialog = true;
                        return [2 /*return*/];
                    case 9:
                        self_.startLoading();
                        getAlreadyEkycUrl = self_.$invokeUrlMaker.create("sales_force/get_already_ekyc/" + this.salesForceInfo.torihikisakiId);
                        _a.label = 10;
                    case 10:
                        _a.trys.push([10, 12, , 13]);
                        return [4 /*yield*/, axios_1.default.get(getAlreadyEkycUrl, {
                                headers: {
                                    Authorization: "Bearer " + authToken
                                }
                            })];
                    case 11:
                        alreadyEkycData = _a.sent();
                        if (alreadyEkycData.data.alreadyEkyc.length !== 0) {
                            alreadyEkycArray = null;
                            alreadyEkycArray = alreadyEkycData.data.alreadyEkyc;
                            // 契約開始日の降順にソートする
                            alreadyEkycArray.sort(function (a, b) {
                                return dayjs_1.default(b.contractStartDate).valueOf() - dayjs_1.default(a.contractStartDate).valueOf();
                            });
                            // 最初の要素が最新の日付を持つオブジェクトをセットする。
                            self_.alreadyEkycLatestRecord = alreadyEkycArray[0];
                            // データが存在する際には、最新の日付を持つオブジェクトをインスタンス変数にもセットする。
                            if (alreadyEkycArray[0]) {
                                self_.salesForceInfo.alreadyEkycLatestRecord = alreadyEkycArray[0];
                            }
                            else {
                                self_.salesForceInfo.alreadyEkycLatestRecord = '';
                            }
                        }
                        return [3 /*break*/, 13];
                    case 12:
                        error_3 = _a.sent();
                        console.log(error_3);
                        self_.endLoading();
                        self_.alertDialogMessage = '取引先に既にeKYCが登録されているかチェックする過程でエラーが発生しました。。開発に連絡してください！！';
                        self_.showAlertDialog = true;
                        return [2 /*return*/];
                    case 13: return [4 /*yield*/, this.fetchSalesForceInfo({
                            salesForceInfo: this.salesForceInfo,
                            fetchTypes: [
                                ReflectType_1.SalesForceReflectType.TORIHIKISAKI,
                                ReflectType_1.SalesForceReflectType.SEKININSYA_APPLY,
                                ReflectType_1.SalesForceReflectType.OPPORTUNITY
                            ]
                        })];
                    case 14:
                        salesForceInfo = _a.sent();
                        if (!Object.keys(salesForceInfo).length) {
                            return [2 /*return*/];
                        }
                        /* 事業所に紐付いていない取引先責任者(申込者)が入力されているかチェック 202401初期リリースではコメントアウト
                        if (salesForceInfo['contractApplyAccountId'] !== salesForceInfo['accountId']) {
                            self_.alertDialogMessage = `事業所に紐付いていない取引先責任者(申込者)が入力されています。IDを確認してください。`;
                            self_.showAlertDialog = true;
                            return;
                        }
                        */
                        Object.keys(self_.documentData).forEach(function (key) {
                            if (salesForceInfo[key]) {
                                self_.documentData[key] = salesForceInfo[key];
                            }
                        });
                        // 商談のリード関係をSET
                        this.salesForceInfo.opportunityLeadSource = value_checker_1.default.isPresent(salesForceInfo['opportunityLeadSource']) ? salesForceInfo['opportunityLeadSource'] : '';
                        this.salesForceInfo.opportunityLtParentLs = value_checker_1.default.isPresent(salesForceInfo['opportunityLtParentLs']) ? salesForceInfo['opportunityLtParentLs'] : '';
                        this.salesForceInfo.opportunityLtSdate = value_checker_1.default.isPresent(salesForceInfo['opportunityLtSdate']) ? salesForceInfo['opportunityLtSdate'] : '';
                        this.salesForceInfo.opportunityGc = value_checker_1.default.isPresent(salesForceInfo['opportunityGc']) ? salesForceInfo['opportunityGc'] : '';
                        this.salesForceInfo.opportunityFtChildLs = value_checker_1.default.isPresent(salesForceInfo['opportunityFtChildLs']) ? salesForceInfo['opportunityFtChildLs'] : '';
                        this.salesForceInfo.opportunityLtChildLs = value_checker_1.default.isPresent(salesForceInfo['opportunityLtChildLs']) ? salesForceInfo['opportunityLtChildLs'] : '';
                        this.documentData.requestInfoHowToRequest = object_utils_1.default.getDBHowToApplyValue(this.documentData.requestInfoHowToRequest);
                        this.documentData.requestInfoHowToSend = object_utils_1.default.getDBHowToApplyValue(this.documentData.requestInfoHowToSend);
                        this.documentData.interimRequestInfoOfficeName = value_checker_1.default.isPresent(this.documentData.interimRequestInfoOfficeName) ? this.documentData.interimRequestInfoOfficeName : '';
                        this.documentData.interimRequestInfoHojinName = value_checker_1.default.isPresent(this.documentData.interimRequestInfoHojinName) ? this.documentData.interimRequestInfoHojinName : '';
                        this.documentData.interimRequestInfoZip1 = value_checker_1.default.isPresent(this.documentData.interimRequestInfoZip1) ? this.documentData.interimRequestInfoZip1 : '';
                        this.documentData.interimRequestInfoZip2 = value_checker_1.default.isPresent(this.documentData.interimRequestInfoZip2) ? this.documentData.interimRequestInfoZip2 : '';
                        this.documentData.interimRequestInfoAddress1 = value_checker_1.default.isPresent(this.documentData.interimRequestInfoAddress1) ? this.documentData.interimRequestInfoAddress1 : '';
                        this.documentData.interimRequestInfoAddress2 = value_checker_1.default.isPresent(this.documentData.interimRequestInfoAddress2) ? this.documentData.interimRequestInfoAddress2 : '';
                        this.documentData.interimRequestInfoAddress3 = value_checker_1.default.isPresent(this.documentData.interimRequestInfoAddress3) ? this.documentData.interimRequestInfoAddress3 : '';
                        this.documentData.interimRequestInfoTel = value_checker_1.default.isPresent(this.documentData.interimRequestInfoTel) ? this.documentData.interimRequestInfoTel : '';
                        this.documentData.interimRequestInfoEmail = value_checker_1.default.isPresent(this.documentData.interimRequestInfoEmail) ? this.documentData.interimRequestInfoEmail : '';
                        this.documentData.interimRequestInfoPersonLastName = value_checker_1.default.isPresent(this.documentData.interimRequestInfoPersonLastName) ? this.documentData.interimRequestInfoPersonLastName : '';
                        this.documentData.interimRequestInfoPersonFirstName = value_checker_1.default.isPresent(this.documentData.interimRequestInfoPersonFirstName) ? this.documentData.interimRequestInfoPersonFirstName : '';
                        this.documentData.interimRequestInfoWay = value_checker_1.default.isPresent(this.documentData.interimRequestInfoWay) ? this.documentData.interimRequestInfoWay : '';
                        this.documentData.interimRequestInfoNotification = value_checker_1.default.isPresent(this.documentData.interimRequestInfoNotification) ? this.documentData.interimRequestInfoNotification : '';
                        if (value_checker_1.default.isPresent(this.documentData.requestInfoHowToRequest) ||
                            value_checker_1.default.isPresent(this.documentData.requestInfoHowToSend)) {
                            this.documentData.requestInfoIsReadOnly = 'true';
                        }
                        else {
                            this.documentData.requestInfoIsReadOnly = '';
                        }
                        self_.loadComplete = true;
                        return [2 /*return*/];
                }
            });
        });
    };
    ReflectSalesForcePre.prototype.startLoading = function () {
        this.loading = true;
    };
    ReflectSalesForcePre.prototype.endLoading = function () {
        this.loading = false;
    };
    ReflectSalesForcePre.prototype.showReloadButton = function () {
        return value_checker_1.default.isPresent(this.getDocumentId_());
    };
    ReflectSalesForcePre.prototype.createNewPlan = function () {
        this.setDocumentId_('');
        this.$router.push({ path: '/sales_force_pre' });
        this.$router.go(0);
    };
    ReflectSalesForcePre.prototype.getSeparateZip = function (postalCode) {
        var zip1 = '';
        var zip2 = '';
        if (!postalCode) {
            return [zip1, zip2];
        }
        var splittedPostalCode = postalCode.split('-');
        if (splittedPostalCode.length !== 2) {
            return [zip1, zip2];
        }
        return [splittedPostalCode[0], splittedPostalCode[1]];
    };
    ReflectSalesForcePre.prototype.mounted = function () {
        return __awaiter(this, void 0, void 0, function () {
            var self_, documentId, authToken, _a, getUserUrl, userData, getPriceBook2Url, priceBook2Data, getDocumentUrl, documentData;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        self_ = this;
                        this.$emit('title-change', this.$t('view.sales_force.reflect.titles.pre'));
                        self_.startLoading();
                        this.$cognito.setLoginCode(this.$route.query['code']);
                        documentId = this.getDocumentId_();
                        if (documentId) {
                            this.setDocumentId_(documentId);
                        }
                        return [4 /*yield*/, this.getAuthToken()];
                    case 1:
                        authToken = _b.sent();
                        if (!authToken) {
                            self_.endLoading();
                            return [2 /*return*/];
                        }
                        _a = this;
                        return [4 /*yield*/, this.$cognito.getUserEmail()];
                    case 2:
                        _a.signInEmail = _b.sent();
                        this.documentData.documentId = documentId;
                        this.salesForceInfo.documentId = documentId;
                        getUserUrl = this.$invokeUrlMaker.create('sales_force/get_user');
                        return [4 /*yield*/, axios_1.default.post(getUserUrl, JSON.stringify({
                                email: this.signInEmail
                            }), {
                                headers: {
                                    Authorization: "Bearer " + authToken
                                }
                            }).catch(function () {
                                self_.endLoading();
                                self_.$router.push({ path: '/' });
                            })];
                    case 3:
                        userData = _b.sent();
                        if (!userData) {
                            self_.endLoading();
                            return [2 /*return*/];
                        }
                        this.salesForceUserId = userData.data['userId'];
                        getPriceBook2Url = this.$invokeUrlMaker.create('sales_force/get_pricebook2');
                        return [4 /*yield*/, axios_1.default.get(getPriceBook2Url, {
                                headers: {
                                    Authorization: "Bearer " + authToken
                                }
                            })];
                    case 4:
                        priceBook2Data = _b.sent();
                        this.priceBook2Data = priceBook2Data.data['priceBookList'];
                        this.priceBookDataList.forEach(function (priceBookData) {
                            _this[priceBookData.priceBookName] = _this.priceBook2Data.filter(function (item) {
                                return item[priceBookData.priceBookFlg] === true;
                            });
                            _this[priceBookData.priceBookName].unshift({
                                value: '',
                                text: _this.$t('dictionary.select.default_text'),
                                IsStandard: '',
                                Description: ''
                            });
                        });
                        if (!documentId) {
                            self_.endLoading();
                            return [2 /*return*/];
                        }
                        getDocumentUrl = this.$invokeUrlMaker.create("get/admin/" + documentId);
                        return [4 /*yield*/, axios_1.default.get(getDocumentUrl, {
                                headers: {
                                    Authorization: "Bearer " + authToken
                                }
                            }).catch(function (e) {
                                self_.endLoading();
                                self_.$router.push({ path: '/' });
                            })];
                    case 5:
                        documentData = _b.sent();
                        self_.endLoading();
                        if (!documentData) {
                            return [2 /*return*/];
                        }
                        if (documentData.data['salesForce']) {
                            self_.salesForceInfo = documentData.data['salesForce'];
                            self_.loadComplete = true;
                        }
                        if (documentData.data['document']) {
                            self_.documentData = documentData.data['document'];
                            self_.upgradeTabDisabled(self_.documentData.validUpgradeToStandardFlg);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    ReflectSalesForcePre.prototype.getDocumentId_ = function () {
        if (this.$route.params['documentId']) {
            return this.$route.params['documentId'];
        }
        try {
            return localStorage.getItem(ReflectSalesForcePre_1.LOCAL_STORAGE_KEY);
        }
        catch (e) {
        }
    };
    ReflectSalesForcePre.prototype.setDocumentId_ = function (documentId) {
        try {
            localStorage.setItem(ReflectSalesForcePre_1.LOCAL_STORAGE_KEY, documentId);
        }
        catch (e) {
        }
    };
    ReflectSalesForcePre.prototype.fetchSalesForceInfo = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var self_, authToken, url_, result, getCorporateAddressDataUrl, corporateAddressData, separateZip, error_4, getUpgradeToStandardDataUrl, upgradeToStandardData, error_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        self_ = this;
                        self_.startLoading();
                        return [4 /*yield*/, this.getAuthToken()];
                    case 1:
                        authToken = _a.sent();
                        url_ = this.$invokeUrlMaker.create('sales_force/get');
                        console.log(data);
                        return [4 /*yield*/, axios_1.default.post(url_, JSON.stringify({
                                salesForceInfo: data['salesForceInfo'],
                                fetchTypes: data['fetchTypes']
                            }), {
                                headers: {
                                    Authorization: "Bearer " + authToken
                                }
                            }).catch(function () {
                                self_.endLoading();
                                self_.alertDialogMessage = 'SalesForce連携で、エラーが発生しました。。開発に連絡してください！！';
                                self_.showAlertDialog = true;
                                return {};
                            })];
                    case 2:
                        result = _a.sent();
                        console.log(result['data']['apiResult']);
                        if (result['data']['apiResult']['errorMessage']) {
                            self_.alertDialogMessage = "SalesForce\u60C5\u5831\u306E\u53D6\u5F97\u306B\u5931\u6557\u3057\u307E\u3057\u305F\u3002\u3002<br>ErrorMessage: " + result['data']['apiResult']['errorMessage'];
                            self_.showAlertDialog = true;
                            return [2 /*return*/, {}];
                        }
                        console.log(result['data']['apiResult']);
                        // 取引先責任者にメールアドレスがあるかチェック
                        if (value_checker_1.default.isBlank(result['data']['apiResult']['officeInfoRequestEmail'])) {
                            self_.endLoading();
                            self_.alertDialogMessage = '取引先責任者（申込者）のメールアドレスがSalesForceに登録されていません。<br> 取引先責任者（申込者）のメールアドレスを登録の上、もう一度申込みをお願いします。';
                            self_.showAlertDialog = true;
                            return [2 /*return*/, {}];
                        }
                        getCorporateAddressDataUrl = this.$invokeUrlMaker.create("sales_force/get_corporate_address/" + this.salesForceInfo.torihikisakiId);
                        _a.label = 3;
                    case 3:
                        _a.trys.push([3, 5, , 6]);
                        return [4 /*yield*/, axios_1.default.get(getCorporateAddressDataUrl, {
                                headers: {
                                    Authorization: "Bearer " + authToken
                                }
                            })];
                    case 4:
                        corporateAddressData = _a.sent();
                        if (corporateAddressData.data['corporateAddressDataObj'].length !== 0) {
                            this.salesForceInfo.corporateId = corporateAddressData.data['corporateAddressDataObj'].corporateId;
                            separateZip = this.getSeparateZip(corporateAddressData.data['corporateAddressDataObj'].officeInfoCorporateZipCode);
                            this.documentData.officeInfoCorporateName = corporateAddressData.data['corporateAddressDataObj'].officeInfoCorporateName;
                            this.documentData.officeInfoCompanyNo = corporateAddressData.data['corporateAddressDataObj'].officeInfoCompanyNo;
                            this.documentData.officeInfoCorporateZip1 = separateZip[0];
                            this.documentData.officeInfoCorporateZip2 = separateZip[1];
                            this.documentData.officeInfoCorporateAddress1 = corporateAddressData.data['corporateAddressDataObj'].officeInfoCorporateAddress1;
                            this.documentData.officeInfoCorporateAddress2 = corporateAddressData.data['corporateAddressDataObj'].officeInfoCorporateAddress2;
                            this.documentData.officeInfoCorporateAddress3 = corporateAddressData.data['corporateAddressDataObj'].officeInfoCorporateAddress3;
                        }
                        else {
                            self_.endLoading();
                            self_.alertDialogMessage = '【法人】レコードが存在しない取引先は申し込むことはできません。';
                            self_.showAlertDialog = true;
                            return [2 /*return*/, {}];
                        }
                        ;
                        return [3 /*break*/, 6];
                    case 5:
                        error_4 = _a.sent();
                        self_.endLoading();
                        self_.alertDialogMessage = '法人情報取得で、エラーが発生しました。。開発に連絡してください！！';
                        self_.showAlertDialog = true;
                        return [2 /*return*/, {}];
                    case 6:
                        getUpgradeToStandardDataUrl = this.$invokeUrlMaker.create("sales_force/get_upgrade/" + this.salesForceInfo.torihikisakiId);
                        _a.label = 7;
                    case 7:
                        _a.trys.push([7, 9, , 10]);
                        return [4 /*yield*/, axios_1.default.get(getUpgradeToStandardDataUrl, {
                                headers: {
                                    Authorization: "Bearer " + authToken
                                }
                            })];
                    case 8:
                        upgradeToStandardData = _a.sent();
                        if (upgradeToStandardData.data['toUpgradeDataList']) {
                            // Object型を配列に変換
                            // this.upgradeToStandardDataList = [Object.assign({}, upgradeToStandardData.data['upgradeToStandardDataList'])];
                            this.upgradeToStandardDataList = upgradeToStandardData.data['toUpgradeDataList'];
                            this.disabledUpgradeTab = false;
                        }
                        return [3 /*break*/, 10];
                    case 9:
                        error_5 = _a.sent();
                        self_.endLoading();
                        self_.alertDialogMessage = 'Standardアップグレード対象データ取得で、エラーが発生しました。。開発に連絡してください！！';
                        self_.showAlertDialog = true;
                        return [2 /*return*/, {}];
                    case 10:
                        // アップグレード対象リスト End
                        self_.endLoading();
                        return [2 /*return*/, result['data']['apiResult']];
                }
            });
        });
    };
    Object.defineProperty(ReflectSalesForcePre, "LOCAL_STORAGE_KEY", {
        get: function () {
            return 'rehaplan.contract_application.sales_force.pre';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ReflectSalesForcePre, "LOGIN_REDIRECT_PATH_", {
        get: function () {
            return 'sales_force_pre';
        },
        enumerable: true,
        configurable: true
    });
    var ReflectSalesForcePre_1;
    ReflectSalesForcePre = ReflectSalesForcePre_1 = __decorate([
        vue_property_decorator_1.Component({
            components: {
                OpportunityBasicPre: OpportunityBasicPre_1.default,
                OpportunityEntryPre: OpportunityEntryPre_1.default,
                OpportunityMediumPre: OpportunityMediumPre_1.default,
                OpportunityOldStandardPre: OpportunityOldStandardPre_1.default,
                OpportunityStandardPre: OpportunityStandardPre_1.default,
                OpportunityProfessionalPre: OpportunityProfessionalPre_1.default,
                OpportunityUpgradeToStandardPre: OpportunityUpgradeToStandardPre_1.default,
                OpportunityAdditionalTabletPre: OpportunityAdditionalTabletPre_1.default,
                OpportunityMotionAiPre: OpportunityMotionAiPre_1.default,
                OpportunityUpgradePre: OpportunityUpgradePre_1.default,
                ApplicationDetailsPre: ApplicationDetailsPre_1.default,
                ApplicationDetails: ApplicationDetails_1.default,
                PriceBookSelect: PriceBookSelect_1.default,
                MoveSalesForceButton: MoveSalesForceButton_1.default,
                Loading: Loading_1.default,
                SimpleDialog: SimpleDialog_1.default,
                TorihikisakiSekininsyaTanto: TorihikisakiSekininsyaTanto_1.default,
                TorihikisakiSekininsyaApply: TorihikisakiSekininsyaApply_1.default,
                Torihikisaki: Torihikisaki_1.default,
                DetailDataSingleLabel: DetailDataSingleLabel_1.default
            }
        })
    ], ReflectSalesForcePre);
    return ReflectSalesForcePre;
}(vue_property_decorator_1.Vue));
exports.default = ReflectSalesForcePre;



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/sales_force/ReflectSalesForcePre.vue
// module id = hZQE
// module chunks = 1